import type { GlsLaunchParams } from '@/game-client/hooks/use-gls';
import { computeLaunchJackpotMode } from '@/features/SWJ/helpers/jackpot-mode-launch';
import resolveLaunchGameUidFromLocation from '@/lostHooks/gameUid/resolveLaunchGameUidFromLocation';
import { useStore } from '@/store/useStore';

export const buildGlsLaunchParamsFromStore = (
  urlGameUid?: string | null,
): GlsLaunchParams | null => {
  const state = useStore.getState();
  const launchGameUid =
    resolveLaunchGameUidFromLocation() ?? urlGameUid ?? null;
  const geolocationToken = state.geolocationContext.geolocationToken;
  const { userId, authToken, loginToken } = state.userSessionContext;
  const authJwt = authToken?.jwt;
  const loginJwt = loginToken?.jwt;

  if (!launchGameUid || !geolocationToken || !userId || !authJwt || !loginJwt) {
    return null;
  }

  return {
    userId,
    authToken: authJwt,
    loginToken: loginJwt,
    gameUid: launchGameUid,
    geolocationToken,
    region: state.runtime.region ?? undefined,
    glsPlatform: state.runtime.glsPlatform,
    jackpotMode: computeLaunchJackpotMode(),
  };
};
